<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="evgSkuFtyCode"
      auto-resize
      highlight-hover-row
      :height="800"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayNo="{ row }">
        <TableLabel
          :label="'SKU'"
          labelKey="table_label_evgSkuNo"
          :value="row.evgSkuNo"
          primary
        />
        <TableLabel
          :label="'SPU'"
          labelKey="table_label_evgSpuNo"
          :value="row.evgSpuNo"
        />
        <TableLabel
          :label="'EAN'"
          labelKey="table_label_eanCode"
          :value="row.eanCode"
        />
        <span>VC：</span>
        <el-tag size="mini" :type="row.isVc == 'Y' ? 'warning' : ''">
          {{ row.v_isVc }}
        </el-tag>
      </template>
      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
      </template>
      <template v-slot:displaySpec="{ row }">
        <TableLabel
          :label="'COLOR'"
          labelKey="table_label_goodsColor"
          :value="`${row.goodsColor || ''} ${row.goodsColorEn || ''}`"
        />
        <TableLabel
          :label="'SIZE'"
          labelKey="table_label_goodsSize"
          :value="row.goodsSize"
        />
        <TableLabel
          :label="'花型'"
          labelKey="table_label_goodsPattern"
          :value="row.goodsPattern"
        />
        <TableLabel
          :label="'款式'"
          labelKey="table_label_goodsStyle"
          :value="row.goodsStyle"
        />
        <TableLabel
          :label="'入数'"
          labelKey="table_label_inCtnQty"
          :value="row.inCtnQty"
          primary
        />
      </template>
      <template v-slot:displayBrandCategory="{ row }">
        <TableLabel
          :label="'BRAND'"
          labelKey="table_label_brandName"
          :value="row.brandName"
        />
        <TableLabel
          :label="'CATEGORY'"
          labelKey="table_label_masterCategoryName"
          :value="
            `${row.masterCategoryName || ''} ${row.detailCategoryName || ''}`
          "
        />
      </template>
      <template v-slot:displayScm="{ row }">
        <TableLabel :value="row.scmName" />
        <TableLabel
          :label="'NC'"
          labelKey="table_label_ncNo"
          :value="row.ncNo"
          primary
        />
        <TableLabel
          :label="'PRICE'"
          labelKey="table_label_ftyPrice"
          :value="`${row.ftyPrice || '0'} ${row.v_ftyPriceCurrencyUnit || ''}`"
        />
      </template>
      <template v-slot:displayGoodsSpec="{ row }">
        <TableLabel
          :label="'面积(㎡)'"
          labelKey="table_label_goodsArea"
          :value="row.goodsArea"
        />
        <TableLabel
          :label="'重量(KG)'"
          labelKey="table_label_goodsWeight"
          :value="row.goodsWeight"
        />
      </template>
      <template v-slot:displayUnitSpec="{ row }">
        <TableLabel
          :label="'SPEC'"
          labelKey="table_label_unitSpec"
          :value="
            `${row.unitLength || '0'}cm * ${row.unitWidth ||
              '0'}cm * ${row.unitHeight || '0'}cm`
          "
        />
        <TableLabel
          :label="'体积(m³)'"
          labelKey="table_label_unitCbm"
          :value="row.unitCbm"
        />
        <TableLabel
          :label="'重量(KG)'"
          labelKey="table_label_unitWeight"
          :value="row.unitWeight"
        />
      </template>
      <template v-slot:displayCtnSpec="{ row }">
        <TableLabel
          :label="'SPEC'"
          labelKey="table_label_ctnSpec"
          :value="
            `${row.ctnLength || '0'}cm * ${row.ctnWidth ||
              '0'}cm * ${row.ctnHeight || '0'}cm`
          "
        />
        <TableLabel
          :label="'体积(m³)'"
          labelKey="table_label_ctnCbm"
          :value="row.ctnCbm"
        />
        <TableLabel
          :label="'毛重(KG)'"
          labelKey="table_label_ctnGrossWeight"
          :value="row.ctnGrossWeight"
        />
        <TableLabel
          :label="'净重(KG)'"
          labelKey="table_label_ctnNetWeight"
          :value="row.ctnNetWeight"
        />
      </template>

      <template v-slot:displayHscode="{ row }">
        <TableLabel
          :label="'HSCODE'"
          labelKey="table_label_hscodeCn"
          :value="row.hscodeCn"
        />
        <TableLabel :value="row.hscodeName" />
        <TableLabel :value="row.hscodeNameEn" />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableLabel from './label.vue'
import tableColumns from './table-columns'
export default {
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'displayImage']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
